export default {
      id: "league-bronze-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#league-bronze",
      toString: function () {
        return this.url;
      }
    }